import request from 'superagent';
import {addGetParameters} from "../../utils";
import { useUTMLabels } from '@hook/useUTMLabels';

export function wantItButtonClicked() {
    return (state) => {
        state.isModalOpen = true;
        return state;
    }
}

export function wantSendQuestion() {
  return (state) => {
    state.isModalOpen = true;
    return state;
  }
}

export function wantItFormSubmit({eventStream, data, text}) {
    const {
        getUTMLabels,
    } = useUTMLabels();

    const utmLabels = getUTMLabels();
    const allUtmLabels = utmLabels.allUtmLabels.map((label) => ({
        utm_source: label.utmSource,
        utm_medium: label.utmMedium,
        utm_campaign: label.utmCampaign,
    }));

    request
        .post(data.url)
        .set('X-Requested-With', 'XMLHttpRequest')
        .type('form')
        .send({csrfmiddlewaretoken: data.config.csrfToken})
        .send({
            body: text,
            product: data.signedProduct,
            ...(utmLabels.lastUtmLabels && {
                utm_labels: JSON.stringify({
                    utm_source: utmLabels.lastUtmLabels.utmSource,
                    utm_medium: utmLabels.lastUtmLabels.utmMedium,
                    utm_campaign: utmLabels.lastUtmLabels.utmCampaign,
                }),
            }),
            ...(utmLabels.allUtmLabels.length && {
                all_utm_labels: JSON.stringify(allUtmLabels),
            }),
        })
        .end(function (err, response) {
            eventStream.next({
                action: 'wantItFormSubmitResponseReceived',
                response: response,
                data: data
            })
        });
    return function (state) {
        state.isSubmitting = true;
        return state;
    }
}

export function wantItFormSubmitResponseReceived({response, data}) {
    return (state) => {
        if (response && response.ok && response.body) {
            if (response.body.errors) {
                state.form.errors = response.body.errors;
                state.isSubmitting = false;
            } else {
                let redirect = function() {
                    addGetParameters(
                        response.body.redirect_to,
                        [
                            {
                                name: 'start_conversation',
                                value: true,
                            },
                            {
                                name: 'username',
                                value: data.member.username,
                            },
                            {
                                name: 'productId',
                                value: data.product.id,
                            },
                        ]
                    );
                };
                redirect();
            }
        } else {
            state.isSubmitting = false;
        }
        return state;
    }
}

export function toggleFavouriteButton() {
    return (state) => {
        let isLiked = state.isActive;

        if (isLiked) {
            state.starred_times--
        } else {
            state.starred_times++
        }

        state.isActive = !isLiked;

        return state;
    }
}

export function closeClicked() {
    return (state) => {
        state.isModalOpen = false;
        return state;
    }
}
